function Breadcrumb({ nodes }) {
  const baseStyle = `cursor-pointer text-white hover:text-yellow-500`;
  const breadcrumbNodes = getBreadCrumb(nodes);
  return (
    <>
      {breadcrumbNodes.map((node, index) => (
        <li
          className={`flex items-center m-breadcrumb ${index}`}
          key={index + "-breadcrumb"}
        >
          {breadcrumbNodes.length > 1 ? (
            <a
              className={`${
                index === 1 ? "m-breadcrumb_link" : "hidden sm:block"
              } ${baseStyle}`}
              href={`${node[0]}`}
            >{`${node[1]}`}</a>
          ) : (
            <a
              className={`m-breadcrumb_link ${baseStyle}`}
              href={`${node[0]}`}
            >{`${node[1]}`}</a>
          )}
          <svg
            className="hidden sm:block fill-current text-white w-3 h-3 mx-3"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 320 512"
          >
            <path d="M285.476 272.971L91.132 467.314c-9.373 9.373-24.569 9.373-33.941 0l-22.667-22.667c-9.357-9.357-9.375-24.522-.04-33.901L188.505 256 34.484 101.255c-9.335-9.379-9.317-24.544.04-33.901l22.667-22.667c9.373-9.373 24.569-9.373 33.941 0L285.475 239.03c9.373 9.372 9.373 24.568.001 33.941z" />
          </svg>
        </li>
      ))}
    </>
  );
}
function getBreadCrumb(_rawParentPage) {
  const nodes = _rawParentPage;
  const result = [];
  if (nodes === null) {
    return result;
  }
  let curr = nodes;
  // add all sanityParentPage up to top-level
  while (curr?.parentPage !== undefined) {
    const path = curr.path ? curr.path : curr.slug.current;
    const title = curr.breadcrumbTitle ? curr.breadcrumbTitle : curr.title;
    result.push([
      path,
      curr.breadcrumbTitle ? curr.breadcrumbTitle : curr.title,
    ]);
    curr = curr.parentPage;
  }
  const title = curr.breadcrumbTitle ? curr.breadcrumbTitle : curr.title;
  result.push([curr.path ? curr.path : curr.slug.current, title]);

  result.reverse();
  return result;
}

export default Breadcrumb;
